export enum SaleMethods {
    NotApplicable = 0,
    Retail = 1,
    WholeSale = 2,

    /**For Vehicle Sales */
    Brooker = 3,
    /**For Vehicle Sales */
    Internal = 4,
    /**For Vehicle Sales */
    Government = 5,
    /**For Vehicle Sales */
    Fleet = 6,
    InterDealer = 7
}